import type { SxProps, Theme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { type Language, useLanguage } from '@/shared/i18n';
import { useThemeMode } from '@/shared/lib';
import { Icon } from './icon';
import { SegmentedControl } from './segmented-control';
import { TileIconButton } from './tile-icon-button';

/** DE / EN switch from the prototype header. */
export function LanguageSwitch({ sx }: { sx?: SxProps<Theme> }) {
  const { language, setLanguage } = useLanguage();
  return (
    <SegmentedControl<Language>
      label="Sprache / Language"
      value={language}
      onChange={setLanguage}
      size="sm"
      headingFont
      options={[
        { value: 'de', label: 'DE' },
        { value: 'en', label: 'EN' },
      ]}
      sx={sx}
    />
  );
}

/** Light/dark toggle tile. */
export function ThemeToggleButton() {
  const { t } = useTranslation();
  const { isDark, toggle } = useThemeMode();
  return (
    <TileIconButton label={t('header.toggleTheme')} onClick={toggle}>
      <Icon name={isDark ? 'sun' : 'moon'} />
    </TileIconButton>
  );
}
